export const data = {
  "time": 1572712253468,
  "blocks": [
    {
      "type": "header",
      "data": {
        "text": "Image",
        "level": 4
      }
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type": "image",
      "data": {
        "file": {
          "url": "https://firebasestorage.googleapis.com/v0/b/editorjs-react-renderer.appspot.com/o/editorjs-react-renderer%20-%20npm%206.png?alt=media&token=74f2d7e5-2c9c-4cd4-bcd0-1c99282dd266"
        },
        "caption": "https://bomdisoft.com",
        "withBorder": false,
        "stretched": false,
        "withBackground": false
      }
    },
    {
      "type": "header",
      "data": {
        "text": "Embed",
        "level": 4
      }
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type" : "embed",
      "data" : {
        "service" : "coub",
        "source" : "https://coub.com/view/1czcdf",
        "embed" : "https://www.youtube.com/embed/RsMikJZhnSQ",
        "caption" : "My Life",
      }
    },
    {
      "type": "header",
      "data": {
        "text": "Delimiter",
        "level": 4
      }
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!&nbsp;Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type": "delimiter",
      "data": {}
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!&nbsp;Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type": "header",
      "data": {
        "text": "Personality",
        "level": 4
      }
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!&nbsp;Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type" : "personality",
      "data" : {
        "name" : "Elon Musk",
        "description" : "Elon Reeve Musk FRS is a technology entrepreneur, investor, and engineer. He holds South African, Canadian, and U.S. citizenship and is the founder",
        "link" : "https://twitter.com/elonmusk",
        "photo" : "https://capella.pics/3c0e1b97-bc56-4961-b54e-2a6c2c3260f2.jpg"
      }
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type": "header",
      "data": {
        "text": "Link",
        "level": 4
      }
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!&nbsp;Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type" : "linkTool",
      "data" : {
        "link" : "https://codex.so",
        "meta" : {
          "title" : "CodeX Team",
          "site_name" : "CodeX",
          "description" : "Club of web-development, design and marketing. We build team learning how to build full-valued projects on the world market.",
          "image" : {
            "url" : "https://codex.so/public/app/img/meta_img.png"
          }
        }
      }
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!&nbsp;Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type": "header",
      "data": {
        "text": "Code block",
        "level": 4
      }
    },
    {
      "type": "codeBox",
      "data": {
        "code": ".codeBoxTextArea{\n  width: 100%;\n  min-height: 30px;\n  padding: 10px;\n  border-radius: 2px 2px 2px 0;\n  border: none !important;\n  outline: none !important;\n  font: 14px monospace;\n}\n\n.codeBoxSelectDiv{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  position: relative;\n}",
        "language": "css",
        "theme": "https://cdn.jsdelivr.net/gh/highlightjs/cdn-release@9.18.1/build/styles/atom-one-dark.min.css"
      }
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type": "header",
      "data": {
        "text": "Lists",
        "level": 4
      }
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type": "checklist",
      "data": {
        "items": [
          {
            "text": "Gather requirements",
            "checked": true
          },
          {
            "text": "Develop API",
            "checked": true
          },
          {
            "text": "Notify stakeholders",
            "checked": false
          },
          {
            "text": "Develop Web App",
            "checked": false
          }
        ]
      }
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type": "list",
      "data": {
        "style": "ordered",
        "items": [
          "First iteration",
          "Second iteration"
        ]
      }
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type": "list",
      "data": {
        "style": "unordered",
        "items": [
          "Item one",
          "Item two"
        ]
      }
    },
    {
      "type": "header",
      "data": {
        "text": "Table",
        "level": 4
      }
    },
    {
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type": "table",
      "data": {
        "content": [
          [
            "<div class=\"tc-table__area\"><div class=\"tc-table__inp\">Name</div></div>",
            "<div class=\"tc-table__area\"><div class=\"tc-table__inp\">Age</div></div>",
            "<div class=\"tc-table__area\"><div class=\"tc-table__inp\">Position</div></div>",
            "<div class=\"tc-table__area\"><div class=\"tc-table__inp\">SSN</div></div>"
          ],
          [
            "<div class=\"tc-table__area\"><div class=\"tc-table__inp\">Jack&nbsp;</div></div>",
            "<div class=\"tc-table__area\"><div class=\"tc-table__inp\">51</div></div>",
            "<div class=\"tc-table__area\"><div class=\"tc-table__inp\">All trades</div></div>",
            "<div class=\"tc-table__area\"><div class=\"tc-table__inp\">654654414131333</div></div>"
          ],
          [
            "<div class=\"tc-table__area\"><div class=\"tc-table__inp\">John Doe</div></div>",
            "<div class=\"tc-table__area\"><div class=\"tc-table__inp\">21</div></div>",
            "<div class=\"tc-table__area\"><div class=\"tc-table__inp\">Senior Consultant</div></div>",
            "<div class=\"tc-table__area\"><div class=\"tc-table__inp\">0002145465145641</div></div>"
          ]
        ]
      }
    },
    {
      "type": "header",
      "data": {
        "text": "Warning and simple video",
        "level": 4
      }
    },
    {
      "type": "warning",
      "data": {
        "title": "",
        "message": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem temporibus quae distinctio facilis in minus quaerat non illum adipisci ab similique eos est eligendi cumque, quibusdam, fugit voluptates omnis pariatur!"
      }
    },
    {
      "type" : "video",
      "data" : {
        // "url" : "https://paul.kinlan.me/videos/2019-11-05--test-post-video-upload-0.mp4",
        "file": { "url" : "https://paul.kinlan.me/videos/2019-11-05--test-post-video-upload-0.mp4" },
        "caption" : "An aweomse video",
        "autoplay" : false,
        "controls" : false,
        "muted": false,
        "stretched" : false
      }
    },
    {
      "type": "header",
      "data": {
        "text": "Custom Renderer",
        "level": 4
      }
    },
    {
      "type": "avatar",
      "data": {
        "imageURL": "https://firebasestorage.googleapis.com/v0/b/bomdisoft-28c17.appspot.com/o/logo%2Flogo%20icon%20white%20-%20192.png?alt=media&token=b1cf145a-89b9-43f4-bcbe-7380cce32138"
      }
    },
  ],
  "version": "2.14.0"
};
